import { FormikHelpers } from 'formik';
import { HTMLAttributes } from 'react';

export enum TaxTypesEnum {
  SingleTax = 'Single Tax',
  MilitaryTax = 'Military Fee',
  ESV = 'Unified Social Tax',
}

export interface ITaxDataFormValues {
  id?: string;
  targetDate: Date;
  amountUah: number;
  taxType: TaxTypesEnum;
}

export interface ITaxEventFormProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onSubmit'> {
  onSubmit: (
    data: ITaxDataFormValues,
    resetForm: FormikHelpers<ITaxDataFormValues>,
  ) => Promise<void>;
  initialValues: ITaxDataFormValues;
}
